import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { type OTP } from "./entity";

export const OTPEntityConfig: HyperEntityConfig<OTP> = {
  allowApiCrud: false,
  allowApiRead: false,
};
